import {
    defaultFont
} from './common-style'

const requisitionFormStyle = theme => ({
    main: {
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'center'
    },
    form: {
        width: "65%",
    },
    input: {
        ...defaultFont,
        color: "#AAAAAA !important",
        fontWeight: "300",
        fontSize: "13px",
        lineHeight: "2",
        maxHeight:"50px",
        borderRadius: "5px 5px 5px 5px",
        boxShadow: "rgba(0, 0, 0, 0.35)",
        margin: "15px auto"
    },
    input_area: {
        ...defaultFont,
        color: "#AAAAAA !important",
        fontWeight: "300",
        fontSize: "13px",
    },
    select: {
        margin: "15px auto"
    },
    chips: {
        display: 'flex',
        flexWrap: 'wrap',
        margin: "15px auto"
    },
    button: {
        minWidth: "100px",
        textTransform: "none",
        color: "#FFFFFF"
    },
    prev_button: {
        minWidth: "100px",
        textTransform: "none",
        color: "#000000"
    },
})

export default requisitionFormStyle
